import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";

import API_URL from "../../config";

const EditJob = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [job, setJob] = useState({
        role: "",
        skills_required: "",
        experience_required: "",
        salary: "",
        location: ""
    });

    useEffect(() => {

        fetchJob();

    }, []);

    const fetchJob = async () => {

        try {

            const response = await axios.get(
                `${API_URL}/admin/jobs/${id}`
            );

            setJob(response.data.data);

        } catch (err) {

            console.error(err);

            alert("Unable to load job.");

        } finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        setJob({

            ...job,

            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await axios.put(

                `${API_URL}/admin/jobs/${id}`,

                job

            );

            alert("Job updated successfully.");

            navigate("/admin/jobs");

        } catch (err) {

            console.error(err);

            alert("Update failed.");

        }

    };

    if (loading) {

        return (

            <Loader
                fullScreen
                text="Loading Job..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader
                title="Edit Job"
                subtitle="Update Job Details"
                showButton={false}
                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Jobs",
                        link: "/admin/jobs"
                    },
                    {
                        label: "Edit Job"
                    }
                ]}
            />

            <div className="bg-white rounded-3xl shadow-lg p-8">

                <form
                    onSubmit={handleSubmit}
                    className="grid grid-cols-1 md:grid-cols-2 gap-6"
                >

                    <div>

                        <label className="block mb-2 font-medium">

                            Job Role

                        </label>

                        <input
                            type="text"
                            name="role"
                            value={job.role}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />

                    </div>

                    <div>

                        <label className="block mb-2 font-medium">

                            Experience Required

                        </label>

                        <input
                            type="text"
                            name="experience_required"
                            value={job.experience_required}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />

                    </div>

                    <div>

                        <label className="block mb-2 font-medium">

                            Salary

                        </label>

                        <input
                            type="text"
                            name="salary"
                            value={job.salary}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />

                    </div>

                    <div>

                        <label className="block mb-2 font-medium">

                            Location

                        </label>

                        <input
                            type="text"
                            name="location"
                            value={job.location}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />

                    </div>

                    <div className="md:col-span-2">

                        <label className="block mb-2 font-medium">

                            Skills Required

                        </label>

                        <textarea
                            rows="5"
                            name="skills_required"
                            value={job.skills_required}
                            onChange={handleChange}
                            className="w-full border rounded-xl px-4 py-3"
                        />

                    </div>

                    <div className="flex justify-end gap-4 md:col-span-2">

                        <button
                            type="button"
                            onClick={() => navigate("/admin/jobs")}
                            className="px-6 py-3 rounded-xl bg-gray-200 hover:bg-gray-300"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-3 rounded-xl bg-teal-600 text-white hover:bg-teal-700"
                        >
                            Update Job
                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

};

export default EditJob;